module.exports = __webpack_public_path__ + "static/media/fregate.9f27f40d.jpg";